import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { Checkbox } from "@mui/material";
import { forwardRef } from "react";

const visible = <VisibilityOutlined fontSize="small" />;

const visibleOff = <VisibilityOffOutlined fontSize="small" />;

export const VisibilityToggle = forwardRef(
  (props: any, ref: React.Ref<HTMLInputElement>) => {
    return (
      <Checkbox
        icon={visibleOff}
        checkedIcon={visible}
        disableRipple
        disableFocusRipple
        {...props}
        ref={ref}
        sx={{
          color: "inherit",
          "&.Mui-checked": {
            color: "inherit",
          },
        }}
      />
    );
  }
);
